/**
 * Displays a small badge indicating the origin of a PABLO config's weight set.
 *
 * Possible states:
 *   - "Manual"                  — weights were set manually by a user
 *   - "Auto-generated"          — weights come from a fresh random simulation variation
 *   - "Historical re-selected"  — weights originated from a historical config that outperformed
 *                                  all new random variations in the latest simulation run
 */
const ConfigOriginBadge = ({ config }) => {
  if (!config) return null;

  const isAutoGenerated = config.userId === "PABLO";
  const sourceConfigId = config.riskEvaluation?.sourceConfigId;

  const label = !isAutoGenerated
    ? "Manual"
    : sourceConfigId != null
      ? `Historical re-selected (from config #${sourceConfigId})`
      : "Auto-generated";

  const style = {
    fontSize: "0.82em",
    fontWeight: "bold",
    color: "#1565c0",
  };

  return <span style={style}>{label}</span>;
};

export default ConfigOriginBadge;
